<template>
  <component :is="componentTag" />
</template>
<script>
import webAboutUs from './web';
import mobileAboutUs from './mobile';
export default {
  components: {
    webAboutUs,
    mobileAboutUs
  },
  data() {
    return {
       isMobile: false,
       componentTag: ''
    };
  },
  created() {
     this.listenObserverWidth(750);
  },
  methods: {
    // 监听可视窗口宽度
    listenObserverWidth(mobileWidth) {
       const resizeObserver = new ResizeObserver(entries => {
          for(let entry of entries) {
             if(entry.contentRect.width <= mobileWidth) {
                this.componentTag = 'mobileAboutUs';
             } else {
                this.componentTag = 'webAboutUs';
             }
          }
       });
       resizeObserver.observe(document.body);
    }
  },
};
</script>